// extracted by mini-css-extract-plugin
export default {"banner":"pP4Fu","clickable":"i0GSc","bottomBanner":"Cyniy","bottomSupportedAppBanner":"PGKJX","bannerBg":"MPaJW","logo":"PkeOI","text":"D2C6V","button":"RT3OI"};